<script>
  export let version;
</script>

<section name="revision">
  <p>Revision: {version} · © 2020 Hendrik Runte</p>
</section>
